module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"in-layer-results":"Dans:","color":"Couleur","grey":"Gris","aerial":"Aérienne"},"de":{}}')
  delete Component.options._Ctor
}
